import { getColor } from "./shared.js";
import { Text } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/Subtitle2.tsx
const Subtitle2 = ({ children, color = "gray", icon = false, inline = false, ta, "data-testid": testId }) => /* @__PURE__ */ jsx(Text, {
	size: "lg",
	component: inline ? "span" : "p",
	fw: 600,
	ta,
	"data-testid": testId,
	style: {
		color: getColor(color, true),
		blockSize: icon ? "var(--text-lh, var(--mantine-line-height-xl))" : "auto",
		display: inline ? "inline-block" : "block",
		textWrap: "pretty"
	},
	children
});

//#endregion
export { Subtitle2 };